import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { Network, Percent, Calendar, Building2 } from 'lucide-react';

export default function CompanyPartnershipsPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const { data, error } = await supabase
      .from('company_partnerships')
      .select(`
        *,
        company:companies!company_partnerships_company_id_fkey(name),
        partner:companies!company_partnerships_partner_company_id_fkey(name)
      `)
      .order('created_at', { ascending: false });
    
    if (error) console.error('Erreur:', error);
    else setData(data);
    setLoading(false);
  }

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6 text-cyan-400 flex items-center gap-2">
        <Network size={24} />
        Partenariats ({data.length})
      </h2>
      
      {loading ? (
        <p className="text-gray-400">Chargement...</p>
      ) : (
        <div className="grid grid-cols-1 gap-4">
          {data.map(partnership => (
            <div key={partnership.id} className="bg-gray-900 rounded-xl border border-gray-800 p-5 hover:border-cyan-500/50 transition">
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-4 mb-3">
                    <div className="flex items-center gap-2">
                      <Building2 size={18} className="text-cyan-400" />
                      <span className="text-white font-medium">{partnership.company?.name || 'N/C'}</span>
                    </div>
                    <Network size={18} className="text-gray-600" />
                    <div className="flex items-center gap-2">
                      <Building2 size={18} className="text-purple-400" />
                      <span className="text-white font-medium">{partnership.partner?.name || 'N/C'}</span>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <p className="text-gray-500">Type de partenariat</p>
                      <p className="text-white">{partnership.partnership_type || 'Standard'}</p>
                    </div>
                    <div>
                      <p className="text-gray-500 flex items-center gap-1">
                        <Percent size={14} />
                        Commission
                      </p>
                      <p className="text-green-400 font-bold">{partnership.commission_rate}%</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-4 mt-3 text-xs">
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      partnership.is_active ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
                    }`}>
                      {partnership.is_active ? 'Actif' : 'Inactif'}
                    </span>
                    <span className="text-gray-500 flex items-center gap-1">
                      <Calendar size={12} />
                      Créé le: {new Date(partnership.created_at).toLocaleDateString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}